import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { MdOutlineNavigateNext } from 'react-icons/md';
import { GrFormPrevious } from 'react-icons/gr';
import RideHistoryTable from '../components/RideHistoryTable';

const Employee = () => {
  const [ridesData, setRidesData] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);
  const [searchQuery, setSearchQuery] = useState('');

  useEffect(() => {
    const fetchRides = async () => {
      const authKey = localStorage.getItem('key');
      const companyId = localStorage.getItem('authToken');

      const formData = new FormData();
      formData.append('key', authKey);
      formData.append('cid', companyId);

      try {
        const response = await fetch(
          'https://app.mindstreamsoft.com/ride_history.php',
          {
            method: 'POST',
            body: formData,
          }
        );
        const data = await response.json();
        setRidesData(data);
      } catch (error) {
        console.error('Error fetching ride history:', error);
      }
    };
    fetchRides();
  }, []);

  const entriesPerPage = 9;
  const totalEntries = ridesData.length;
  const totalPages = Math.ceil(totalEntries / entriesPerPage);
  const startEntry = (currentPage - 1) * entriesPerPage + 1;
  const endEntry = Math.min(startEntry + entriesPerPage - 1, totalEntries);

  const handlePrevPage = () => setCurrentPage((prev) => Math.max(prev - 1, 1));
  const handleNextPage = () =>
    setCurrentPage((prev) => Math.min(prev + 1, totalPages));

  const filteredRides = ridesData.filter((ride) =>
    Object.values(ride)
      .join(' ')
      .toLowerCase()
      .includes(searchQuery.toLowerCase())
  );

  return (
    <div className='dashboard-container'>
      <div className='content'>
        <div className='card'>
          <div className='d-flex justify-content-between align-items-center flex-wrap p-4'>
            <div className='d-flex flex-column flex-md-row align-items-md-center'>
              <input
                type='text'
                placeholder='Search'
                className='form-control flex-grow-1 me-md-3 mb-3 mb-md-0 border-0'
                style={{
                  maxWidth: '250px',
                  borderRadius: '30px',
                  background: '#f5f7fa',
                  color: '#969696',
                }}
                value={searchQuery}
                onChange={(e) => setSearchQuery(e.target.value)}
              />
              <select
                className='form-select border-0 me-md-3 mb-3 mb-md-0'
                style={{
                  maxWidth: '170px',
                  borderRadius: '30px',
                  background: '#f5f7fa',
                  color: '#969696',
                }}
              >
                <option value='newest'>Sort by: Newest</option>
                <option value='oldest'>Sort by: Oldest</option>
              </select>
            </div>
            <div className='d-flex flex-column flex-md-row align-items-start align-items-md-center'>
              <Link
                to='#'
                className='btn mt-md-3 me-md-3 mb-3 mb-md-0'
                style={{
                  backgroundColor: '#ffff',
                  color: '#1f1f21',
                  textDecoration: 'none',
                  border: '1px solid #969696',
                  borderRadius: '10px',
                  fontWeight: '600',
                }}
              >
                Export CSV
              </Link>
              <Link
                to='/book-ride'
                className='btn mt-md-3'
                style={{
                  backgroundColor: '#f37a20',
                  color: '#fff',
                  textDecoration: 'none',
                  borderRadius: '10px',
                }}
              >
                Book New Ride
              </Link>
            </div>
          </div>

          <RideHistoryTable
            rides={filteredRides}
            startEntry={startEntry}
            endEntry={endEntry}
          />

          <div className='d-flex justify-content-between align-items-center flex-wrap p-4'>
            <div>
              <span style={{ color: '#969696' }}>
                Showing {startEntry}-{endEntry} of {totalEntries} entries
              </span>
            </div>
            {totalEntries > entriesPerPage && (
              <div>
                <button
                  className='btn btn-link me-2'
                  style={{ borderRadius: '10px', border: '1px solid #969696' }}
                  disabled={currentPage === 1}
                  onClick={handlePrevPage}
                >
                  <GrFormPrevious style={{ fontSize: '20px' }} />
                </button>
                <button
                  className='btn btn-link'
                  style={{ borderRadius: '10px', border: '1px solid #969696' }}
                  disabled={currentPage === totalPages}
                  onClick={handleNextPage}
                >
                  <MdOutlineNavigateNext style={{ fontSize: '20px' }} />
                </button>
              </div>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default Employee;
